import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=ffaa56b2&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=ts&setup=true"
export * from "./Filters.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Filters.vue?vue&type=style&index=0&id=ffaa56b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaa56b2",
  null
  
)

export default component.exports